import { render, staticRenderFns } from "./TestInstallContractSignModal.vue?vue&type=template&id=6820d20e"
import script from "./TestInstallContractSignModal.vue?vue&type=script&lang=js"
export * from "./TestInstallContractSignModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports